/**
 * Whether saving a movement can change what the lists are built from.
 *
 * A group header counts and sums movements by date, type, currency, category,
 * account or goal, and a list's order and membership follow the same fields.
 * An edit that touches none of them — a note, the tags — leaves every header
 * and every window as it was: the row itself is patched and nothing is read
 * again. Anything not named here is deliberately left out of the comparison.
 */
const LIST_FIELDS = [
  'type', 'date', 'amount', 'currency',
  'account_id', 'from_account_id', 'to_account_id', 'category_id',
  'ignored_at', 'movement_group_id',
];

const goalIdOf = (movement) => movement.goal?.id ?? null;

const exchangeOf = (movement) => {
  const exchange = movement.currency_exchange;
  return exchange ? `${exchange.currency_target}:${exchange.value_target}` : null;
};

/**
 * `before` is the row as the list had it, `after` what the server saved. With
 * either one missing there is nothing to compare, and the safe answer is that
 * the edit did change something.
 */
export function movementShapesLists(before, after) {
  if (!before || !after) return true;
  return LIST_FIELDS.some((field) => before[field] !== after[field])
    || goalIdOf(before) !== goalIdOf(after)
    || exchangeOf(before) !== exchangeOf(after);
}
